import { ViewMode } from '../store/types';

export const DEFAULT_VIEW_MODE = ViewMode.mainData;
